User's last login: {{(user.lastLogin | formatdatetime) || 'Never'}}
